import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { updateState } from "../../../redux/commonSlice";
import { eventDetails } from "../../../services/api";

export default (id)=> {
    const dispatch = useDispatch();
    const [payload, setPayload] = useState()
    const [enableEventDetail, setEnableEventDetail] = useState(true)
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const reviewEventReducer = useSelector((state) => state.reviewEventReducer);
    ////////////////////////////query for event detail//////////////////////////
  const {
    data: eventDetailData,
    isLoading: eventDetailLoading,
    error: eventDetailError,
    refetch: refetchEventDetail,
  } = useQuery(
    [`EventDetail${id}${commonReducer.new_video}`, id, commonReducer.new_video],
    () => eventDetails({id: id}),
    { enabled: enableEventDetail , retry: false }
  );

//   const checkEventFlag = (events)=>{
//     const filteredEvents = events?.filter(event => event.Event_accepted == false);
//     return filteredEvents.length > 0;
//   }

// const getEventDetails = (eventId) => {
//    // setPayload({event_id: eventId});
//     setEnableEventDetail(true)
// }

  useEffect(()=> {
    if(eventDetailData) {
      setEnableEventDetail(false)  
     // const eventDetails = eventDetailData?.data?.data
      dispatch(updateState({event_details: eventDetailData?.data?.data}))
    }
  }, [eventDetailData])
return [refetchEventDetail]

}